import { FC, useEffect, useState } from 'react'
import { Download, X } from 'lucide-react'
import { PDF_VIEWER_EVENT, type PdfViewerPayload } from '@utils/pdfViewer'

export const PdfViewerModal: FC = () => {
  const [current, setCurrent] = useState<PdfViewerPayload | null>(null)

  useEffect(() => {
    const handleOpen = (e: Event) => {
      const detail = (e as CustomEvent<PdfViewerPayload>).detail
      if (detail?.src) setCurrent(detail)
    }
    window.addEventListener(PDF_VIEWER_EVENT, handleOpen)
    return () => window.removeEventListener(PDF_VIEWER_EVENT, handleOpen)
  }, [])

  if (!current) return null

  const handleClose = () => {
    if (current.src.startsWith('blob:')) URL.revokeObjectURL(current.src)
    setCurrent(null)
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black/50"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full h-full sm:h-[90vh] sm:max-w-5xl flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-3 sm:p-4 border-b border-gray-100 shrink-0">
          <h3 className="text-base sm:text-lg font-bold text-gray-900 truncate mr-2">
            {current.title}
          </h3>
          <div className="flex items-center gap-2 shrink-0">
            <a
              href={current.src}
              download={current.filename || current.src.split('/').pop() || 'documento.pdf'}
              className="p-1.5 rounded-lg text-gray-400 hover:text-cofarte-purple hover:bg-cofarte-purple/5 transition-colors"
              title="Descargar PDF"
            >
              <Download className="h-5 w-5" />
            </a>
            <button
              onClick={handleClose}
              className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100"
              title="Cerrar"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-hidden">
          <iframe src={current.src} className="w-full h-full border-0" title={current.title} />
        </div>
      </div>
    </div>
  )
}
